import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ecommerceBaseUrl } from "network";

export const sizeSlice = createApi({
    reducerPath: "sizeSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: ecommerceBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getSizes: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/size?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addSizes: builder.mutation({
            query: (body) => ({
                url: "/size",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateSizes: builder.mutation({
            query: ({ id, body }) => ({
                url: `/size/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteSizes: builder.mutation({
            query: (id) => ({
                url: `/size/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetSizesQuery,
    useAddSizesMutation,
    useUpdateSizesMutation,
    useDeleteSizesMutation
} = sizeSlice;
